module.exports = __webpack_public_path__ + "static/media/clinician-balancing-es-1080p.d099a9b0.mp4";